import { ApiKeyManagement } from "@client/components/api-key-management";
import { BackButton, PageContainer, PageHeader } from "@client/components/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/settings/api-keys")({
	component: ApiKeysPage,
});

function ApiKeysPage() {
	return (
		<PageContainer maxWidth="narrow">
			<BackButton to="/settings" label="Back to Settings" />

			<PageHeader
				title="API Keys"
				description="Create and manage your API keys for programmatic access"
			/>

			<ApiKeyManagement />
		</PageContainer>
	);
}
